var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabTatca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_18412)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 1.875C0.75 1.57663 0.868526 1.29048 1.0795 1.0795C1.29048 0.868526 1.57663 0.75 1.875 0.75H4.125C4.42337 0.75 4.70952 0.868526 4.9205 1.0795C5.13147 1.29048 5.25 1.57663 5.25 1.875V4.125C5.25 4.42337 5.13147 4.70952 4.9205 4.9205C4.70952 5.13147 4.42337 5.25 4.125 5.25H1.875C1.57663 5.25 1.29048 5.13147 1.0795 4.9205C0.868526 4.70952 0.75 4.42337 0.75 4.125V1.875ZM6.75 1.875C6.75 1.57663 6.86853 1.29048 7.0795 1.0795C7.29048 0.868526 7.57663 0.75 7.875 0.75H10.125C10.4234 0.75 10.7095 0.868526 10.9205 1.0795C11.1315 1.29048 11.25 1.57663 11.25 1.875V4.125C11.25 4.42337 11.1315 4.70952 10.9205 4.9205C10.7095 5.13147 10.4234 5.25 10.125 5.25H7.875C7.57663 5.25 7.29048 5.13147 7.0795 4.9205C6.86853 4.70952 6.75 4.42337 6.75 4.125V1.875ZM0.75 7.875C0.75 7.57663 0.868526 7.29048 1.0795 7.0795C1.29048 6.86853 1.57663 6.75 1.875 6.75H4.125C4.42337 6.75 4.70952 6.86853 4.9205 7.0795C5.13147 7.29048 5.25 7.57663 5.25 7.875V10.125C5.25 10.4234 5.13147 10.7095 4.9205 10.9205C4.70952 11.1315 4.42337 11.25 4.125 11.25H1.875C1.57663 11.25 1.29048 11.1315 1.0795 10.9205C0.868526 10.7095 0.75 10.4234 0.75 10.125V7.875ZM6.75 7.875C6.75 7.57663 6.86853 7.29048 7.0795 7.0795C7.29048 6.86853 7.57663 6.75 7.875 6.75H10.125C10.4234 6.75 10.7095 6.86853 10.9205 7.0795C11.1315 7.29048 11.25 7.57663 11.25 7.875V10.125C11.25 10.4234 11.1315 10.7095 10.9205 10.9205C10.7095 11.1315 10.4234 11.25 10.125 11.25H7.875C7.57663 11.25 7.29048 11.1315 7.0795 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.875Z",
    fill: "#231E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_18412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabTatca);
export default __webpack_public_path__ + "static/media/tab-tatca.eefaae20865c6bf9e7190ab11bedd5c1.svg";
export { ForwardRef as ReactComponent };